module.exports = __webpack_public_path__ + "img/visit.0141c7da.png";